import { where } from 'firebase/firestore'
import { chunk } from 'lodash'

import FirestoreService from '../../firestoreService'

import { getConvertedData } from '../../../models/interface.helper'

import { HorseModel } from '../../../models/horse/horse.model'
import { HorseCompetitonPaperworkModel } from '../../../models/horse-competiton-paperwork/horse-competiton-paperwork.model'
import { RegistrationByDayModel } from '../../../models/registrations-by-day/registrationByDay.model'

import { IHorseData } from '../../../models/horse/horse.interface'
import { IHorseCompetitorDocument } from '../../../models/horse-competiton-paperwork/horse-competiton-paperwork-interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

const getById = async (id: string) => {
  const horsesSnapShot = await FirestoreService.getItem(COLLECTIONS.HORSES.NAME, id)
  return getConvertedData(HorseModel.fromFirestoreDoc(horsesSnapShot).toObject())
}

const getHorsesByIds = async (ids: string[]) => {
  const horsesById: IHorseData[] = []

  if (ids?.[0]) {
    const chunks = chunk(ids, 30) // Firestore limits the 'in' clause to 30 items

    const queries = chunks.map((idsChunk) =>
      FirestoreService.getItemsUsingIds(COLLECTIONS.HORSES.NAME, idsChunk)
    )

    const snapshotsArray = await Promise.all(queries)

    snapshotsArray.forEach((snapshots) => {
      snapshots.forEach((doc) => {
        const current = getConvertedData(HorseModel.fromFirestoreDoc(doc).toObject())
        horsesById.push(current)
      })
    })
  }

  return horsesById
}
const getAllHorseInfo = async (userId: string, eventId: string) => {
  const competitionPaperworkSnap = await FirestoreService.filterItems(
    CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.HORSE_COMPETITION_PAPERWORK.NAME
  )

  let competitionPaperwork = competitionPaperworkSnap?.docs.map((doc: any) => {
    return HorseCompetitonPaperworkModel.fromFirestoreDoc(doc).toObject()
  })

  const allHorsesSnap = await FirestoreService.filterItems(
    CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.HORSES.NAME
  )

  let allHorses = allHorsesSnap?.docs.map((doc: any) => {
    return HorseModel.fromFirestoreDoc(doc).toObject()
  })

  const registrationByDaySnap = await FirestoreService.filterItems(
    CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.REGISTRATION_BY_DAY.NAME,
    [
      where(
        CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.EVENT_ID.KEY,
        '==',
        eventId
      ),
      where(
        CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.USER_ID.KEY,
        '==',
        userId
      ),
    ]
  )

  let registrationsByDay = registrationByDaySnap?.docs.map((doc: any) => {
    return RegistrationByDayModel.fromFirestoreDoc(doc).toObject()
  })

  const horsesIds: string[] = []
  const registeredHorses: (IHorseData & { paperwork: IHorseCompetitorDocument })[] = []
  registrationsByDay.forEach((registrationByDay) => {
    if (registrationByDay?.horseId) {
      const horse = allHorses.find(
        (current) =>
          current.id && registrationByDay?.horsesSelected.find((horse) => horse.id === current.id)
      )

      if (horse?.id && !horsesIds.includes(horse?.id)) {
        horsesIds.push(horse?.id)
        const filteredPaperwork = competitionPaperwork.filter((current) =>
          horse.horseId ? current.horseId === horse?.horseId : current.horseUniqId === horse.id
        )
        registeredHorses.push({ ...horse, paperwork: filteredPaperwork[0] ?? [] })
      }
    }
  })

  return registeredHorses ?? []
}

const HorsesService = {
  getById,
  getAllHorseInfo,
  getHorsesByIds,
}

export default HorsesService
